import { BigNumber, ethers } from 'ethers'

import { Currency } from '../entities'
import { useWeb3RequestQuery } from '../features/api/web3ApiSlice'
import { getChainData } from '../helpers/utilities'

import IERC20ABI from '../abi/IERC20.abi.json'
import { HookProvider } from './types'

interface CheckAllowanceData {
  provider?: HookProvider
  contract?: string
  currency?: Currency
  account?: string
  amount?: BigNumber
}

interface AllowanceAction {
  allowance?: BigNumber
  isRequired: boolean
  isAllowed: boolean
  isSuccess: boolean
  isError: boolean
  isFetching: boolean
  isLoading: boolean
}

// TODO: Add DOMAIN_SEPARATOR check to prevent redundant transaction
const useSimpleCheckAllowance = ({
  provider, contract, currency, account, amount,
}: CheckAllowanceData): AllowanceAction => {
  const chain = getChainData(currency?.chainId)
  const skip = (
    !currency
    || currency?.isNative
    || !chain
    || (!currency?.isNative && !account)
    || !contract
    || !amount
    || !provider
  )

  const { data: allowanceData, ...allowanceQueryData } = useWeb3RequestQuery({
    provider,
    request: {
      address: currency?.address,
      abi: IERC20ABI,
      method: 'allowance',
      params: [account, contract],
    },
  }, {
    skip,
    pollingInterval: 3_000,
  })

  const allowance = (allowanceData)
    ? allowanceData as BigNumber | undefined
    : undefined

  const isAllowed = amount ? (allowance?.gte(amount || ethers.constants.Zero) || false) : false

  return {
    allowance,
    isRequired: !skip,
    isAllowed: (currency?.isNative || false) || isAllowed,
    isSuccess: allowanceQueryData.isSuccess,
    isError: allowanceQueryData.isError,
    isFetching: allowanceQueryData.isFetching,
    isLoading: allowanceQueryData.isLoading,
  }
}

export default useSimpleCheckAllowance
